<template>
  <div style="min-width: 1200px" class="big">
    <div class="page_title">智能导诊统计</div>
    <div style="padding: 20px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span class="itemtitle">关键字</span>
            <el-input
              v-model="keywords_name"
              @change="search"
              class="inputWidth"
              clearable=""
            />
          </div>
          <div class="item">
            <div class="itemtitle">医生姓名</div>
            <el-input
              v-model="doctor_name"
              @change="search"
              clearable=""
              class="inputWidth"
            />
          </div>
          <div class="item">
            <div class="itemtitle">医生手机号</div>
            <el-input
              v-model="doctor_phone"
              @change="search"
              clearable=""
              class="inputWidth"
            />
          </div>
          <div class="item">
            <div class="itemtitle">用户手机号</div>
            <el-input
              v-model="user_phone"
              class="inputWidth"
              clearable=""
              @change="search"
            />
          </div>
          <div class="item">
            <div class="itemtitle">应用端口</div>
            <el-select
              v-model="app_from"
              placeholder="请选择"
              @change="search"
              class="inputWidth"
            >
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="安卓" :value="1"></el-option>
              <el-option label="iOS" :value="2"></el-option>
              <el-option label="小程序" :value="3"></el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="itemtitle">时间</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 225px"
              @change="search"
              clearable
            ></el-date-picker>
          </div>
          <div class="item">
            <span class="itemtitle">是否进入详情</span>
            <el-radio-group
              v-model="is_info"
              @change="search"
              style="margin-bottom: -4px"
            >
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
          <div class="item">
            <span class="itemtitle">是否咨询</span>
            <el-radio-group
              v-model="is_consult"
              @change="search"
              style="margin-bottom: -4px"
            >
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
          <div class="item">
            <span class="itemtitle">是否接诊</span>
            <el-radio-group
              v-model="is_agree_consult"
              @change="search"
              style="margin-bottom: -4px"
            >
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
          <div class="item">
            <div class="itemtitle">咨询入口</div>
            <el-select
              v-model="consult_from"
              placeholder="请选择"
              @change="search"
              class="inputWidth"
            >
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="匹配页" :value="1"></el-option>
              <el-option label="详情页" :value="2"></el-option>
            </el-select>
            <el-button
              type="info"
              size="medium"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 6px;
              "
              @click="search"
              >查询</el-button
            >
          </div>
        </div>
        <!-- 表格 -->
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1200px"
            :header-cell-style="{ background: '#F5F5F5' }"
            :span-method="objectSpanMethod"
          >
            <el-table-column prop="create_time" label="时间" width="95" />
            <el-table-column label="应用端口" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.app_from == 1">安卓</span>
                <span v-if="scope.row.app_from == 2">iOS</span>
                <span v-if="scope.row.app_from == 3">小程序</span>
              </template>
            </el-table-column>
            <el-table-column width="120">
              <template slot="header">
                <div>患者信息/</div>
                <div>(用户手机号)</div>
              </template>
              <template slot-scope="scope">
                <div>{{ scope.row.real_name }}</div>
                <div>
                  <span v-if="scope.row.sex == 1">男</span>
                  <span v-if="scope.row.sex == 2">女</span>
                  <span style="margin-left: 10px">{{ scope.row.age }}</span>
                </div>
                <div>{{ scope.row.phone }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="desc" label="病症描述" />
            <el-table-column
              label="匹配关键字"
              prop="keywords_name"
              width="120"
            />
            <el-table-column width="130">
              <template slot="header">
                <div>匹配科室/</div>
                <div>(是否为重选科室)</div>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row.department_name }}</span>
                <span
                  v-if="scope.row.is_check == 1 && scope.row.department_name"
                  >(是)</span
                >
                <span
                  v-if="scope.row.is_check == 0 && scope.row.department_name"
                  >(否)</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="匹配医生信息"
              class-name="border-column"
              width="140"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.doctor_name }}</div>
                <div>{{ scope.row.doctor_phone }}</div>
              </template>
            </el-table-column>
            <el-table-column label="是否进入详情" class-name="border-column">
              <template slot-scope="scope">
                <span v-if="scope.row.is_info == 1">{{
                  scope.row.info_time
                }}</span>
                <span v-if="scope.row.is_info == 0">否</span>
              </template>
            </el-table-column>
            <el-table-column label="是否咨询" class-name="border-column">
              <template slot-scope="scope">
                <span v-if="scope.row.is_consult == 0">否</span>
                <div v-if="scope.row.is_consult == 1">
                  <span v-if="scope.row.consult_types == 1">图文问诊</span>
                  <span v-if="scope.row.consult_types == 2">视频问诊</span>
                  <span v-if="scope.row.consult_types == 3">电话问诊</span>
                  <span v-if="scope.row.pay_money"
                    >{{ scope.row.pay_money }}元</span
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    @click="
                      toDetail(scope.row.consult_id, scope.row.consult_types)
                    "
                    style="margin-left: 10px"
                    >详情</el-button
                  >
                  <div>发起时间:{{ scope.row.consult_time }}</div>
                  <div>
                    接诊时间:{{
                      scope.row.agree_consult_time
                        ? scope.row.agree_consult_time
                        : "------"
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="咨询入口"
              class-name="border-column"
              width="130"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.consult_from == 1">匹配页</span>
                <span v-if="scope.row.consult_from == 2">详情页</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      date: [],
      keywords_name: "",
      doctor_name: "",
      doctor_phone: "",
      user_phone: "",
      app_from: -1,
      is_info: -1,
      is_consult: -1,
      is_agree_consult: -1,
      consult_from: -1,
    };
  },
  created() {
    this.getList();
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        keywords_name: this.keywords_name,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        user_phone: this.user_phone,
        app_from: this.app_from,
        is_info: this.is_info,
        is_consult: this.is_consult,
        is_agree_consult: this.is_agree_consult,
        consult_from: this.consult_from,
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.create_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/guidance/getGuidanceMatchLogList", data)
        .then((res) => {
          this.totalNum = res.data.total;
          if (res.data.list.length) {
            this.fomartList(res.data.list);
          } else {
            this.tableData = res.data.list;
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },

    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //格式化列表
    fomartList(list) {
      if (!list.length) {
        return false;
      }
      let arr = [];
      list.forEach((ele) => {
        if (ele.doctor_list || ele.doctor_list.length > 0) {
          let children = [];
          ele.doctor_list.forEach((docInfo, index) => {
            let obj = {
              log_id: ele.log_id,
              create_time: ele.create_time,
              app_from: ele.app_from,
              phone: ele.phone,
              real_name: ele.real_name,
              sex: ele.sex,
              age: ele.age,
              desc: ele.desc,
              keywords_name: ele.keywords_name,
              department_name: ele.department_name,
              is_check: ele.is_check,
              doctor_name: docInfo.doctor_name,
              doctor_phone: docInfo.doctor_phone,
              is_info: docInfo.is_info,
              info_time: docInfo.info_time,
              is_consult: docInfo.is_consult,
              is_agree_consult: docInfo.is_agree_consult,
              consult_time: docInfo.consult_time,
              consult_types: docInfo.consult_types,
              consult_from: docInfo.consult_from,
              consult_id: docInfo.consult_id,
              agree_consult_time: docInfo.agree_consult_time,
            };
            arr.push(obj);
            children.push(obj);
          });
        } else {
          ele.doctor_name = "";
          ele.doctor_phone = "";
          ele.is_info = "";
          ele.info_time = "";
          ele.is_consult = "";
          ele.is_agree_consult = "";
          ele.consult_time = "";
          ele.consult_types = "";
          ele.consult_from = "";
          ele.consult_id = "";
          arr.push(ele);
        }
      });
      this.tableData = arr;
    },
    //合并表格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let num = 0;
      if (
        columnIndex == 0 ||
        columnIndex == 1 ||
        columnIndex == 2 ||
        columnIndex == 3 ||
        columnIndex == 4 ||
        columnIndex == 5
      ) {
        this.tableData.forEach((ele) => {
          if (row.log_id == ele.log_id) {
            num++;
          }
        });
      }
      if (num == 1) {
        return {
          rowspan: 1,
          colspan: 1,
        };
      } else if (num > 1) {
        if (
          this.tableData[rowIndex - 1] &&
          this.tableData[rowIndex].log_id == this.tableData[rowIndex - 1].log_id
        ) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        } else {
          return {
            rowspan: num,
            colspan: 1,
          };
        }
      }
    },
    //超过10个时查看更多
    showMore(row) {
      this.extraData = row.children;
    },
    toDetail(consult_id, consult_types) {
      this.$router.push({
        path: "/home/yewu/wenzhendetail",
        query: { consult_id: consult_id, consult_types: consult_types },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: -10px;
  .inputWidth {
    width: 160px;
  }
  .item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .itemtitle {
      display: inline-block;
      width: 90px;
      text-align: right;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss">
.border-column {
  border-left: 1px solid #ebeef5;
}
</style>